import { sortEventsByDate } from '../../../../../contrib/utils';
import { IAdminEvent } from '../../../../../store/admin/events/store';
import { getOverviewGroups } from './getOverviewGroups';

export interface IOverview {
  eventLabel: string;
  event: IAdminEvent;
}

export const getOverviewEvents = (events: IAdminEvent[]): IOverview[] => {
  if (events.length === 0) {
    return [];
  }

  const overviewEvents: IOverview[] = [];
  const sortedEvents = sortEventsByDate(events);
  const { currentEvents, futureEvents, pastEvents } = getOverviewGroups(sortedEvents);

  currentEvents.forEach(event => {
    overviewEvents.push({ eventLabel: 'current', event });
  });

  futureEvents.slice(0, 3).forEach(event => {
    overviewEvents.push({ eventLabel: 'next', event });
  });

  pastEvents
    .slice(-3)
    .reverse()
    .forEach(event => {
      overviewEvents.push({ eventLabel: 'previous', event });
    });

  return overviewEvents.slice(0, events.length > 3 ? 3 : events.length);
};
